<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [errors]="question.errors"
  [infos]="question.infos"
  [key]="question.key"
  [isBlur]="isBlur"
  [dirty]="dirty"
  [value]="value"
  [type]="question.controlType"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>
<div class="image-input" *ngIf="value && !!question.src; else addPhoto">
  <ion-img [src]="question.src"></ion-img>
  <div class="photo-buttons">
    <ion-button
      fill="clear"
      color="dark"
      class="photo-action-button"
      [disabled]="readonly"
      (click)="takePicture()"
    >
      <ion-icon name="pencil"></ion-icon>
      {{ 'PHOTO.TAKE_AGAIN' | translate }}
    </ion-button>
    <div class="photo-separator"></div>
    <ion-button
      fill="clear"
      color="dark"
      class="photo-action-button"
      [disabled]="readonly"
      (click)="deleteImg()"
    >
      <ion-icon name="trash"></ion-icon>
      {{ 'PHOTO.DELETE' | translate }}
    </ion-button>
  </div>
</div>

<ng-template #addPhoto>
  <ion-item lines="none">
    <ion-button
      fill="clear"
      expand="block"
      class="photo-picker-button"
      [disabled]="readonly"
      aria-label="Add photo"
      (click)="takePicture($event)"
    >
      <span class="photo-picker-text">{{ 'PHOTO.ADD_PHOTO' | translate }}</span>
      <div class="photo-picker-icon-wrapper">
        <ion-icon slot="end" name="camera" size="large"></ion-icon>
      </div>
    </ion-button>
  </ion-item>
</ng-template>
